<script>
	import Bar from './Bar.svelte'
	import Home from './Home.svelte'
	import Ninja from './Ninja.svelte'
	import About from './About.svelte'
	import searchNinja from './SearchNinja.svelte'
	import Router,{location} from 'svelte-spa-router'
	const routes = {
    '/': Home,
	'/about':About,
	'/:id': Ninja,
	'/search/:text': searchNinja,

}
</script>
<Bar/>
<Router {routes}/>
